import React, { useState } from 'react';
import { Chats, CheckSquare, Funnel, MagnifyingGlass, Square, X } from '@phosphor-icons/react';
import { Popover, Sheet } from '../../../../../components/immobilien/ui';
import { FilterPanel, type FilterPanelProps } from './FilterPanel';

const KNOPF: React.CSSProperties = {
  borderRadius: 999, border: 'none', gap: 7, padding: '0 16px', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
};

/**
 * Kopf der Liste (Screen 01/03): Suche, Filter (Popover; mobil als Sheet), „Alle auswählen“, „Konversationen an/aus“.
 * Ersetzt die Suche und Filter aus der Insel-Pille.
 */
export function ListenKopf({ suche, onSuche, onSucheLeeren, filter, alleGewaehlt, onAlleAuswaehlen, konversationen, onKonversationen, zeigeAuswahl, mobil }: {
  suche: string;
  onSuche: (v: string) => void;
  onSucheLeeren: () => void;
  filter: FilterPanelProps;
  alleGewaehlt: boolean;
  onAlleAuswaehlen: () => void;
  konversationen: boolean;
  onKonversationen: () => void;
  /** „Alle auswählen“ / „Konversationen“ nur, wenn Mails da sind (wie bisher). */
  zeigeAuswahl: boolean;
  mobil: boolean;
}) {
  const [sheet, setSheet] = useState(false);
  const h = mobil ? 44 : 40;
  const filterKnopf = (offen: boolean, onClick: () => void, ref?: React.Ref<HTMLButtonElement>) => (
    <button ref={ref} type="button" onClick={onClick} aria-expanded={offen} aria-haspopup="dialog" className="immo-hover-flaeche flex items-center cursor-pointer"
      style={{ ...KNOPF, height: h, background: filter.hatFilter ? 'var(--acc-soft)' : 'var(--fill2)', color: filter.hatFilter ? 'var(--acc)' : 'var(--ink)' }}>
      <Funnel size={15} weight={filter.hatFilter ? 'fill' : 'bold'} />Filter
    </button>
  );

  return (
    <div className="flex flex-col" style={{ gap: 10 }}>
      <div className="flex flex-wrap items-center" style={{ gap: 8 }}>
        <label className="immo-glas flex items-center" style={{ flex: mobil ? '1 1 100%' : '1 1 240px', minWidth: 0, height: mobil ? 44 : 44, borderRadius: 22, gap: 8, padding: '0 6px 0 14px' }}>
          <MagnifyingGlass size={16} color="var(--ink3)" aria-hidden />
          <input type="text" value={suche} onChange={e => onSuche(e.target.value)} placeholder="E-Mails durchsuchen…" aria-label="E-Mails durchsuchen"
            className="flex-1 min-w-0" style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 14, color: 'var(--ink)' }} />
          {suche && (
            <button type="button" aria-label="Suche leeren" onClick={onSucheLeeren} className="flex items-center justify-center cursor-pointer shrink-0"
              style={{ width: mobil ? 36 : 30, height: mobil ? 36 : 30, borderRadius: '50%', border: 'none', background: 'var(--fill2)', color: 'var(--ink2)' }}>
              <X size={12} weight="bold" />
            </button>
          )}
        </label>
        {mobil
          ? filterKnopf(sheet, () => setSheet(true))
          : (
            <Popover label="Filter" breite={420} ausrichtung="rechts"
              ausloeser={({ offen, umschalten, ref }) => filterKnopf(offen, umschalten, ref)}>
              {() => <div style={{ padding: 10 }}><FilterPanel {...filter} /></div>}
            </Popover>
          )}
        {zeigeAuswahl && (
          <button type="button" onClick={onAlleAuswaehlen} aria-pressed={alleGewaehlt} className="immo-hover-flaeche flex items-center cursor-pointer"
            style={{ ...KNOPF, height: h, background: 'var(--fill2)', color: 'var(--ink)' }}>
            {alleGewaehlt ? <CheckSquare size={16} weight="fill" color="var(--acc)" /> : <Square size={16} weight="bold" />}Alle auswählen
          </button>
        )}
      </div>
      {zeigeAuswahl && (
        <div className="flex">
          <button type="button" onClick={onKonversationen} aria-pressed={konversationen}
            title="Zusammengehörige Mails (gleiche Konversation) als eine Zeile gruppieren"
            className="flex items-center cursor-pointer"
            style={{ ...KNOPF, height: mobil ? 44 : 36, background: konversationen ? 'var(--acc-soft)' : 'var(--fill2)', color: konversationen ? 'var(--acc)' : 'var(--ink2)' }}>
            <Chats size={15} weight="bold" />Konversationen {konversationen ? 'an' : 'aus'}
          </button>
        </div>
      )}

      {sheet && (
        <Sheet titel="Filter" onSchliessen={() => setSheet(false)} maxHoehe="85vh">
          <FilterPanel {...filter} hoehe={44} />
        </Sheet>
      )}
    </div>
  );
}
